<template>
  <button
    :class="[
      'btn',
      {
        primaryBtn: stylevariant === 'primary',
        secondaryBtn: stylevariant === 'secondary',
      },
    ]"
    :type="type"
    @click="onClick"
    :style="cus_style"
  >
    <div class="d-flex justify-content-center align-items-center">
      <b-spinner small v-if="loading" style="margin-right: 0.5rem"></b-spinner>
      <slot></slot>
    </div>
  </button>
</template>

<script>
export default {
  emits: ["onClick"],
  props: ["type", "stylevariant", "cus_style", "loading"],
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>

<style scoped>
.btn {
  border-radius: 6px;
  text-transform: capitalize;
  padding: 10px 20px;
  width: -webkit-fill-available;
  cursor: pointer;
  font-family: Roboto_Regular;
}
.btn:focus {
  box-shadow: none;
}
.primaryBtn {
  background-color: #741b47;
  color: #ffe599;
  border: 1px solid #741b47;
}
.primaryBtn:hover {
  background-color: #6b2346;
}
.primaryBtn:disabled {
  opacity: 0.3;
}
.secondaryBtn {
  background-color: #ffffff;
  color: #741b47;
  border: 1px solid #741b47;
}
.secondaryBtn:hover {
  background-color: #741b47;
  color: #ffe599;
}
.secondaryBtn:disabled {
  opacity: 0.3;
}
</style>
